import { apiV2 } from '../lib/baseAxios';

export const initPlugin = async (key: string) => {
  return apiV2.get(`plugin/init/${key}`);
};

export const getPlugin = () => {
  return apiV2.get('plugin/setup');
};

export const setUpPlugin = (data: { website: string }) => {
  return apiV2.post('plugin/setup', data);
};
